export default __webpack_public_path__ + "static/media/Upload=Failed.4163c538.svg";